/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {HealthMonitorLoginRequest} from "../model/health-monitor-login-request";
import {RestartServiceByTypeResponse} from "../model/restart-service-by-type-response";
import {RestartServicesResponse} from "../model/restart-services-response";
import {ServiceType} from "../model/service-type";
import {SystemStatusView} from "../model/system-status-view";

@Injectable({
    providedIn: "root",
})
export class SimHealthMonitorService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getSystemStatus() {
        return super.get<SystemStatusView>(`/api/HealthMonitor/GetSystemStatus`, );
    }

    public hasAccess() {
        return super.get<boolean>(`/api/HealthMonitor/HasAccess`, );
    }

    public login(request: HealthMonitorLoginRequest) {
        return super.post<boolean>(`/api/HealthMonitor/Login`, request);
    }

    public requestSystemStatusOverWs() {
        return super.get<void>(`/api/HealthMonitor/RequestSystemStatusOverWs`, );
    }

    public restartService(guid: string) {
        return super.get<RestartServiceByTypeResponse>(`/api/HealthMonitor/RestartService`, {guid: guid});
    }

    public restartServiceByType(serviceType: ServiceType) {
        return super.get<RestartServiceByTypeResponse>(`/api/HealthMonitor/RestartServiceByType`, {serviceType: serviceType});
    }

    public restartServices() {
        return super.get<RestartServicesResponse>(`/api/HealthMonitor/RestartServices`, );
    }
}